import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, ArrowUpRight, Phone } from "lucide-react";
import { BOOKING_URL, BUSINESS } from "@/config";

/**
 * Re-usable CTA strip dropped at the bottom of subpages.
 */
const PageCTA = () => {
  return (
    <section className="relative py-20 md:py-28 bg-[#151D33] border-y border-[#2C374D]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4"
        >
          Ready when you are
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-display text-4xl md:text-5xl text-white leading-[0.95] tracking-tight"
        >
          GOT A JOB IN MIND?{" "}
          <span className="text-[#D47A4A]">LET'S TALK.</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-2 bg-[#D47A4A] hover:bg-[#B85D2A] text-[#0B132B] font-bold px-8 py-4 rounded-md transition-all uppercase tracking-wider text-sm shadow-lg shadow-[#D47A4A]/25 hover:shadow-[#D47A4A]/50 hover:-translate-y-0.5"
          >
            <Mail className="w-4 h-4" />
            Enquire Now
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
          <a
            href={BUSINESS.phoneHref}
            className="inline-flex items-center justify-center gap-2 border border-[#2C374D] text-[#A0ABC0] hover:text-white hover:border-[#D47A4A]/60 px-7 py-4 rounded-md transition-colors uppercase tracking-wider text-sm"
          >
            <Phone className="w-4 h-4" />
            Call {BUSINESS.phone}
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 text-[#A0ABC0] hover:text-white px-3 py-4 uppercase tracking-wider text-sm"
          >
            More ways to contact us →
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default PageCTA;
